



















import {Component, Vue} from 'vue-property-decorator'

@Component({
    components: {},
})
export default class Signture extends Vue {
    private name: string = '_________'
    private time: string = ''
    private tick: boolean = false
    private changeTick () {
        this.tick = !this.tick
        this.$parent.signature = this.tick
    }
    private renameMethod() {
        this.$parent.showName = true
    }
    private mounted () {
        // this.$parent.showName = true
        this.time = this.$wjh.dateFormat((new Date()).valueOf(), 'hh:mm')
    }

}
